import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const OAuthTokenHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier si on a un token OAuth dans l'URL
    const urlParams = new URLSearchParams(location.search);
    const authStatus = urlParams.get('auth');
    const provider = urlParams.get('provider');
    const token = urlParams.get('token');

    if (authStatus === 'success' && provider === 'google' && token) {
      console.log('🔑 Token OAuth Google reçu:', token ? 'OUI' : 'NON');
      
      // Stocker le token dans localStorage
      localStorage.setItem('authToken', token);
      
      // Configurer axios pour envoyer automatiquement le token
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // Nettoyer l'URL
      const newUrl = location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      
      // Rediriger vers la page d'accueil
      navigate('/', { replace: true });
      
      console.log('✅ Token OAuth configuré et stocké');
    }
  }, [location, navigate]);

  // Ce composant ne rend rien visuellement
  return null;
};

export default OAuthTokenHandler;
